import { version } from '~/package.json'

export default defineAppConfig({
  appVersion: version,
  siteName: 'Pflegering Portal',
  apiBaseUrl: 'https://my.1tool.com/suite/api/',
  apiBaseUrlV2: 'https://my.1tool.com/suite/api/v2/',
  apiBaseUrlV3: 'https://my.1tool.com/suite/api/v3/',
  socketBaseUrl: 'wss://luisgomezdev.com',
  socketAccessToken: 'fpEnmgn9YkXke_cQNAgiCBsaJZH.cX@uw!teqhq8Ys7y9Xft927nykb!woaoG-qC',
  tenantId: '8b5d9bd6-e396-4539-9053-3fb59b2c7c01',
  routing: {
    startPage: 'events'
  },
  vendor: {
    vuelidate: {
      $lazy: true,
      $autoDirty: false
    },
    marked: { headerIds: false, mangle: false }
  },
  ui: {
    primary: 'customPrimary'
  }
})
